module.exports = __webpack_public_path__ + "a54a1321ff9421d770a8e41044f3458c.svg";